import type { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './useFinder.translations'
import type { FinderConfig, FinderOption } from './useFinder.types'

type I18n = ReturnType<typeof useI18n>

export const MACBOOK_SCREEN_SIZES = ['13', '14', '15', '16'] as const

const sizeOptions: FinderOption[] = MACBOOK_SCREEN_SIZES.map((size) => ({
  id: size,
  label: `${size}"`,
  values: [`${size}"`],
}))

export function getMacbookFinderConfig(i18n: I18n): FinderConfig {
  return {
    id: 'apple-macbook',
    criteria: [
      {
        kind: 'usages',
        facetName: 'usages.label',
        title: i18n(translations.usageTitle),
        tooltip: i18n(translations.usageTooltip),
        primaryOptionsCount: 3,
        options: [
          {
            id: 'On-the-go',
            label: i18n(translations.usageOnTheGoLabel),
            values: ['On-the-go'],
          },
          {
            id: 'Daily use',
            label: i18n(translations.usageDailyUseLabel),
            values: ['Daily use'],
          },
          {
            id: 'For creatives',
            label: i18n(translations.usageForCreativesLabel),
            values: ['For creatives'],
          },
          {
            id: 'For complex work',
            label: i18n(translations.usageForComplexWorkLabel),
            values: ['For complex work'],
          },
        ],
      },
      {
        kind: 'budget',
        facetName: 'price',
        title: i18n(translations.budgetTitle),
        presets: [
          { id: 'budget-300', maxValue: 300 },
          { id: 'budget-450', maxValue: 450 },
          { id: 'budget-600', maxValue: 600 },
          { id: 'budget-750', maxValue: 750 },
          { id: 'budget-900', maxValue: 900 },
          { id: 'budget-1050', maxValue: 1050 },
        ],
      },
      {
        kind: 'screensize',
        facetName: 'screen_size',
        title: i18n(translations.sizeTitle),
        rangeMin: 11,
        rangeMax: 16,
        options: sizeOptions,
      },
      {
        kind: 'conditions',
        facetName: 'backbox_grade',
        title: i18n(translations.conditionTitle),
        tooltip: i18n(translations.conditionTooltip),
        options: [
          {
            id: 'fair',
            label: i18n(translations.conditionFairLabel),
            description: i18n(translations.conditionFairDescription),
            values: ['12 Fair'],
          },
          {
            id: 'good',
            label: i18n(translations.conditionGoodLabel),
            description: i18n(translations.conditionGoodDescription),
            values: ['11 Good'],
          },
          {
            id: 'excellent',
            label: i18n(translations.conditionExcellentLabel),
            description: i18n(translations.conditionExcellentDescription),
            values: ['10 Excellent'],
          },
          {
            id: 'premium',
            label: i18n(translations.conditionPremiumLabel),
            description: i18n(translations.conditionPremiumDescription),
            values: ['9 Premium'],
          },
        ],
      },
      {
        kind: 'requirements',
        title: i18n(translations.requirementsTitle),
        moreFiltersLabel: i18n(translations.moreFiltersLabel),
      },
    ],
  }
}
